import { render } from "./MiniTitle.vue?vue&type=template&id=19db2eb2&scoped=true"
import script from "./MiniTitle.vue?vue&type=script&lang=js"
export * from "./MiniTitle.vue?vue&type=script&lang=js"

import "./MiniTitle.vue?vue&type=style&index=0&id=19db2eb2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19db2eb2"]])

export default __exports__